import EditorPluginSetup from "./editors/PluginSetup.js";
import ResultPluginSetup from "./result/PluginSetup.js";
import ValidatorPluginSetup from "./validators/PluginSetup.js";
import AttributeValueEditorSetup from "./attributeValueEditorOverrides/PluginSetup.js";
import BulkUpdateForm from "./BulkUpdateForm.js";
const install = molten => {
  EditorPluginSetup.install(molten);
  ResultPluginSetup.install(molten);
  ValidatorPluginSetup.install(molten);
  AttributeValueEditorSetup.install(molten);

  // Ugly.
  molten.addPlugin('BulkBlueprintForm', {
    type: 'bulkUpdate',
    form: BulkUpdateForm
  });
};
export default {
  install
};